import {
    CityType,
    TransfersDataType
} from "@SearchResults/features/banners/features/getByTransferBanner/types/TransfersData.type";
import ParamsType from "@SearchResults/types/params/Params.type";

export default function hasNoDirectRoutes(transfersData: TransfersDataType, params: ParamsType) {
    const hasNearbyCity = (object: CityType | null): object is CityType => (
        'id' in object
    )

    const noDirectRoutes = transfersData?.noDirectBuses
        && !!transfersData?.departureNearbyCity
        && hasNearbyCity(transfersData.departureNearbyCity)
        && transfersData?.departureNearbyCity?.id !== `${params.destinationStation.id}`

    return {
        noDirectRoutes,
    }
}